// extracted by mini-css-extract-plugin
module.exports = {"formControl":"Dropdown_formControl__Hqepi","label":"Dropdown_label__9DOT1","placeholder":"Dropdown_placeholder__fDiG7"};